import RefundSummaryItem from '@/components/refund/RefundSummaryItem';
import { TransText } from '@/i18n/trans/text';
import { Divider, Icons, Typography } from '@packages/webshop-design-system';
import { type FC } from 'react';

interface RefundSummaryViewProps {
  // The original price paid, before the refund fee is withheld.
  totalPrice: number;
  // The refund fee withheld, as a positive amount; shown negated.
  refundFee: number;
  refundAmount: number | undefined;
}

const RefundSummaryView: FC<RefundSummaryViewProps> = ({
  totalPrice,
  refundFee,
  refundAmount,
}) => (
  <>
    <div className="mb-5">
      <Typography variant="paragraph">
        <TransText i18nKey="refundIssuedText" />
      </Typography>
      <div className="mt-5 flex flex-col gap-2 rounded-lg rounded-b-none border border-neutral-light px-4 py-3">
        <RefundSummaryItem
          icon={
            <Icons.ticketReturn
              height={16}
              width={16}
              className="text-primary"
            />
          }
          title={<TransText i18nKey="totalPrice" />}
          amount={totalPrice}
        />
        <RefundSummaryItem
          icon={<Icons.coin height={16} width={16} className="text-primary" />}
          title={<TransText i18nKey="refundFee" />}
          amount={refundFee ? -refundFee : 0}
        />
      </div>
      <div className="rounded-md rounded-t-none border border-t-0 border-neutral-light bg-primary-pale p-4">
        <RefundSummaryItem
          icon={
            <Icons.buyReturnTicket
              width={16}
              height={16}
              className="text-primary"
            />
          }
          title={<TransText i18nKey="totalRefund" />}
          amount={refundAmount}
          isTotal
        />
      </div>
    </div>
    <Divider />
  </>
);

export default RefundSummaryView;
